import { Observable } from 'rxjs';
import { ValueHelperModel } from '../models/low-level/value-helper.model';
import { InjectionToken } from '@angular/core';
import { ValueHelperState } from '../state/value-helper';

export interface OdataValueHelperInterface {
    getValueHelpers(): Observable<ValueHelperModel[]>;
    getValueHelpersState(): Observable<ValueHelperState[]>;
}

export const OdataValueHelperInstanceToken = new InjectionToken<OdataValueHelperInterface>('OdataValueHelperInterface');
